<template>
	<div v-if="document" class="popup-menu">
		<!-- Открыть документ -->
		<VButton @click="TransportableDocumentsService.edit(document)" material="open_in_new">
			Открыть
		</VButton>

		<!-- Выбрать документ -->
		<VButton @click="$emit('shipmentDocument:selected', document)">
			Выбрать
		</VButton>

		<hr>

		<!-- Создать обычную ЗТК (только Assembly) -->
		<VButton
			v-if="canCreateSingleSender"
			@click="TransportOrdersService.createSingleSenderTransportOrder(document)"
		>
			Создать обычную ЗТК
		</VButton>

		<!-- Создать консолидированную ЗТК (Assembly, Shipment, TransportOrder) -->
		<VButton
			v-if="canCreateConsolidated"
			@click="TransportOrdersService.createConsolidatedTransportOrder(document)"
		>
			Создать конс. ЗТК
		</VButton>

		<!-- Создать ЗТК на забор у поставщика (OrderPosition) -->
		<VButton
			v-if="canCreateOrderPositionPickup"
			@click="TransportOrdersService.createOrderPositionPickupTransportOrder(document)"
		>
			Создать ЗТК на забор
		</VButton>

		<!-- Создать ЗТК на возврат (OrderPosition) -->
		<VButton
			v-if="canCreateReturn"
			@click="TransportOrdersService.createReturnTransportOrder(document)"
		>
			Создать ЗТК на возврат
		</VButton>

		<!-- Создать ЗТК на внутреннее перемещение (Product) -->
		<VButton
			v-if="canCreateInternal"
			@click="TransportOrdersService.createInternalTransportOrder(document)"
		>
			Создать ЗТК на перемещение
		</VButton>

		<hr>

		<!-- История действий -->
		<VButton @click="TransportableDocumentsService.showHistory(document)" material="history">
			История действий
		</VButton>

		<VButton @click="deleteDoc(document)" material="delete">
			Удалить
		</VButton>
	</div>
</template>

<script lang="ts">
import type AbstractShipmentDocument from '@/domains/Abstract/AbstractShipmentDocument';
import TransportableDocumentsService from '@/domains/TransportableDocuments/TransportableDocumentsService';
import TransportOrdersService        from '@/domains/TransportOrders/TransportOrdersService';

export default defineComponent({
	name: 'ShipmentDocumentContextMenu',

	props: {
		document: {
			type: Object as PropType<AbstractShipmentDocument>,
			default: null,
		},
		afterAction: {
			type: Function,
			default: () => {}
		}
	},

	emits: ['shipmentDocument:selected',],


	setup() {
		return {
			TransportableDocumentsService,
			TransportOrdersService,
		};
	},

	computed: {
		documentClass(): string {
			return this.document?.documentClass ?? '';
		},

		/** Обычная ЗТК — один отправитель, только из сборок */
		canCreateSingleSender(): boolean {
			return this.documentClass === 'Assembly';
		},

		/** Консолидированная ЗТК — Assembly/Shipment/TransportOrder */
		canCreateConsolidated(): boolean {
			return this.documentClass === 'Assembly'
				|| this.documentClass === 'Shipment'
				|| this.documentClass === 'TransportOrder';
		},

		/** ЗТК на забор у поставщика — только OrderPosition */
		canCreateOrderPositionPickup(): boolean {
			return this.documentClass === 'OrderPosition';
		},

		/** ЗТК на возврат — только OrderPosition */
		canCreateReturn(): boolean {
			return this.documentClass === 'OrderPosition';
		},

		/** Внутреннее перемещение — только Product */
		canCreateInternal(): boolean {
			return this.documentClass === 'Product';
		},
	},

	methods: {
		async deleteDoc(document) {
			const isOk = await TransportableDocumentsService.delete(document);
			if (isOk) this.afterAction()
		}
	}
});
</script>
